import React, { useState } from 'react';
import api from '../api/axios';
import { useNavigate } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';

const CambiarClave = () => {
  const [nuevaClave, setNuevaClave] = useState('');
  const [confirmarClave, setConfirmarClave] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (nuevaClave !== confirmarClave) {
      setError('Las claves no coinciden.');
      return;
    }

    if (nuevaClave.length < 6) {
      setError('La clave debe tener al menos 6 caracteres.');
      return;
    }

    try {
      const token = localStorage.getItem('token');
      const response = await api.post('/usuarios/cambiar-clave', { nuevaClave }, {
        headers: { Authorization: `Bearer ${token}` }
      });

      const nuevoToken = response.data.token;
      if (nuevoToken) {
        localStorage.setItem('token', nuevoToken);
        const decoded = jwtDecode(nuevoToken);
        localStorage.setItem('user', JSON.stringify({
          id: decoded.id,
          cuenta_id: decoded.cuenta_id,
          rol: decoded.rol,
          requiere_cambio_clave: false
        }));

        console.log('✅ Clave actualizada. Redirigiendo como:', decoded.rol);

        if (decoded.rol === 'admin') {
          navigate('/admin-turnos');
        } else {
          navigate('/dashboard');
        }
      } else {
        setError('No se recibió un token actualizado.');
      }

    } catch (err) {
      console.error('❌ Error al cambiar clave:', err);
      setError(err.response?.data?.error || 'Error al actualizar la clave.');
    }
  };

  return (
    <div className="container mt-5">
      <h2>Cambiar Clave</h2>
      {error && <div className="alert alert-danger">{error}</div>}

      <form onSubmit={handleSubmit}>
        <div className="mb-3">
          <label>Nueva Clave</label>
          <input
            type="password"
            className="form-control"
            value={nuevaClave}
            onChange={(e) => setNuevaClave(e.target.value)}
            required
          />
        </div>
        <div className="mb-3">
          <label>Confirmar Clave</label>
          <input
            type="password"
            className="form-control"
            value={confirmarClave}
            onChange={(e) => setConfirmarClave(e.target.value)}
            required
          />
        </div>
        <button type="submit" className="btn btn-primary">Actualizar Clave</button>
      </form>
    </div>
  );
};

export default CambiarClave;
